const css = require("./css/style.css");
import moveTop from "./js/move-top.js";

const { fallbackApkUrl, appStoreUrl } = require("./download-config.json");

function isIOS() {
  return /iPad|iPhone|iPod/i.test(window.navigator.userAgent) ||
    (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
}

$(document).ready(function () {
  //优化iframe 加载
  $("#about").attr("src", "./about.html");
  if (isIOS()) {
    $("#download").click(function (event) {
      event.preventDefault();
      window.location.href = appStoreUrl;
    });
  }
  $("#download-fallback").click(function (event) {
    event.preventDefault();
    window.location.href = isIOS() ? appStoreUrl : fallbackApkUrl;
  });
  $().UItoTop({ easingType: "easeOutQuart" });
  $("#slider").responsiveSlides({
    auto: true,
    speed: 500,
    namespace: "callbacks",
    pager: true,
  });
  $(".scroll").click(function (event) {
    event.preventDefault();
    $("html,body").animate({ scrollTop: $(this.hash).offset().top }, 1200);
  });
  //图片懒加载
  $("img.lazy").lazyload({ effect: "fadeIn" });
});
export default { css, moveTop };
